/**
 * The measurables the Power Score needs before it can be computed.
 *
 * ⚠️ MULTI-SPORT DEBT — one definition on purpose. This is a hardcoded combine
 * set, and `backend/app/services/power_score.py: compute_power_score` takes no
 * sport argument, so Power Score is football-shaped platform-wide. Keeping the
 * list here means both consumers (PlayerStatsPage and Recruit ▸ Me) share one
 * definition, so making it sport-aware is a single edit rather than a hunt.
 *
 * Do not copy this list into a third place. See
 * docs/superpowers/specs/2026-08-10-web-recruit-ia-design.md §4.1 and
 * docs/RECRUIT-PARITY-AUDIT-2026-08-10.md F7.
 */
export const POWER_SCORE_REQUIRED = [
  { name: 'dash_40', label: '40yd dash' },
  { name: 'vertical_jump', label: 'vertical jump' },
  { name: 'broad_jump', label: 'broad jump' },
  { name: 'short_shuttle', label: 'short shuttle' },
  { name: 'three_cone_drill', label: '3-cone drill' },
  { name: 'height_inches', label: 'height' },
  { name: 'weight_lbs', label: 'weight' },
];

export default POWER_SCORE_REQUIRED;
